export type ContentFactoryPlatformTargetResolution = {
	explicitPlatforms: string[];
	targetPlatforms: string[];
	allPlatformsRequested: boolean;
};

type ContentFactoryPlatformDefinition = {
	id: string;
	label: string;
	pattern: RegExp;
};

const PLATFORM_DEFINITIONS: ContentFactoryPlatformDefinition[] = [
	{
		id: 'telegram',
		label: 'Telegram',
		pattern: /(?:telegram|телеграм(?:е|а|у|ом)?|телег[аиу]|тг|\btg\b)/i
	},
	{
		id: 'vk',
		label: 'VK',
		pattern: /(?:вконтакте|(?:^|[^a-zа-яё0-9])(?:vk|вк)(?=$|[^a-zа-яё0-9]))/i
	},
	{
		id: 'instagram',
		label: 'Instagram',
		pattern: /(?:instagram|insta|инстаграм(?:е|а|у|ом)?|инст[аеуы])/i
	},
	{
		id: 'threads',
		label: 'Threads',
		pattern: /(?:threads|тредс)/i
	},
	{
		id: 'max',
		label: 'MAX',
		pattern: /(?:^|[^a-zа-яё0-9])(?:max|макс)(?=$|[^a-zа-яё0-9])/i
	},
	{
		id: 'youtube',
		label: 'YouTube',
		pattern: /(?:youtube|youtu\.be|ютуб|ютьюб)/i
	},
	{
		id: 'linkedin',
		label: 'LinkedIn',
		pattern: /(?:linkedin|линкедин|линкед ?ин)/i
	},
	{
		id: 'facebook',
		label: 'Facebook',
		pattern: /(?:facebook|фейсбук|(?:^|[^a-zа-яё0-9])фб(?=$|[^a-zа-яё0-9]))/i
	},
	{
		id: 'tiktok',
		label: 'TikTok',
		pattern: /(?:tiktok|tik\s*tok|тикток|тик\s*ток)/i
	},
	{
		id: 'x',
		label: 'X',
		pattern: /(?:twitter|твиттер|(?:для|под|в|на)\s+(?:соцсет\w*\s+)?x(?=$|[^a-zа-яё0-9]))/i
	}
];

const ALL_PLATFORM_TARGET_PATTERNS = [
	/(?:все|всё|всех|всем|кажд(?:ая|ую|ой|ые|ых|ого|ому)?)\s+(?:(?:мо[ияеюх]|наши?[мх]?|подключ[её]нн[а-яё-]*)\s+)?(?:соц(?:иальн[а-яё-]*\s+)?сет[а-яё-]*|площадк[а-яё-]*|платформ[а-яё-]*|канал[а-яё-]*|аккаунт[а-яё-]*)/i,
	/(?:соц(?:иальн[а-яё-]*\s+)?сет[а-яё-]*|площадк[а-яё-]*|платформ[а-яё-]*|канал[а-яё-]*|аккаунт[а-яё-]*)\s+(?:все|всё|целиком|полностью)/i,
	/(?:адаптир[а-яё-]*|сдела[а-яё-]*|подготов[а-яё-]*|созда[а-яё-]*|разлож[а-яё-]*|раскид[а-яё-]*)\s+(?:(?:отдельн[а-яё-]*|разн[а-яё-]*)\s+)?(?:верс[а-яё-]*\s+)?(?:везде|повсюду|для\s+всех)/i,
	/(?:сразу\s+)?(?:везде|повсюду)(?:\s*,?\s*(?:куда|где))?\s+(?:уже\s+)?подключ[а-яё-]*/i,
	/(?:по|для|под|на|во)\s+вс(?:ем|ех|е)\s+подключ[а-яё-]*/i,
	/(?:all|every)\s+(?:connected\s+)?(?:social\s+networks?|platforms?|channels?|accounts?)/i,
	/(?:everywhere|across\s+all\s+(?:connected\s+)?(?:platforms?|channels?))/i
];

const CONTENT_FACTORY_TARGET_PREPOSITION_PATTERN =
	/(?:для|под|в|во|на|по|адаптируй|адаптировать|подготовь|подготовить)\s*$/i;
const CONTENT_FACTORY_TARGET_SUFFIX_PATTERN =
	/^\s*(?:[-—]\s*)?(?:пост[а-яё-]*|верс[а-яё-]*|формат[а-яё-]*|канал[а-яё-]*|публикац[а-яё-]*)/i;
const CONTENT_FACTORY_MULTI_TARGET_ACTION_PATTERN =
	/(?:сдела[а-яё-]*|напиш[а-яё-]*|подготов[а-яё-]*|созда[а-яё-]*|адаптир[а-яё-]*|переработ[а-яё-]*).*(?:пост[а-яё-]*|публикац[а-яё-]*|верс[а-яё-]*|контент[а-яё-]*)/i;
const CONTENT_FACTORY_CHANNEL_START_PATTERN =
	/(?:нача[тл][а-яё-]*|запуст[а-яё-]*|вести|веду|откры[а-яё-]*|созда[а-яё-]*)\s*$/i;
const CONTENT_FACTORY_CHANNEL_OUTPUT_PATTERN =
	/^\s*(?:с|для|через)?\s*(?:одн[а-яё-]*\s+)?(?:полезн[а-яё-]*\s+)?(?:пост[а-яё-]*|публикац[а-яё-]*|контент[а-яё-]*|канал[а-яё-]*)/i;
const CONTENT_FACTORY_NO_PLATFORM_PATTERNS = [
	/(?:без|вне)\s+(?:конкретн[а-яё-]*\s+)?(?:соц(?:иальн[а-яё-]*\s+)?сет[а-яё-]*|площадк[а-яё-]*|платформ[а-яё-]*|канал[а-яё-]*)/i,
	/(?:соц(?:иальн[а-яё-]*\s+)?сет[а-яё-]*|площадк[а-яё-]*|платформ[а-яё-]*|канал[а-яё-]*)\s+(?:не\s+)?(?:выбира[а-яё-]*|указыва[а-яё-]*|назнача[а-яё-]*|привязыва[а-яё-]*|не\s+нужн[а-яё-]*)/i,
	/(?:не\s+)?(?:выбира[а-яё-]*|указыва[а-яё-]*|назнача[а-яё-]*|привязыва[а-яё-]*)\s+(?:(?:к|для)\s+)?(?:никак[а-яё-]*\s+|конкретн[а-яё-]*\s+)?(?:соц(?:иальн[а-яё-]*\s+)?сет[а-яё-]*|площадк[а-яё-]*|платформ[а-яё-]*|канал[а-яё-]*)/i,
	/(?:универсальн[а-яё-]*|нейтральн[а-яё-]*)\s+(?:пост[а-яё-]*|черновик[а-яё-]*|верс[а-яё-]*|текст[а-яё-]*)/i,
	/(?:without|no)\s+(?:(?:a|the)\s+)?(?:specific\s+)?(?:social\s+network|platform|channel)/i
];

export const normalizeContentFactoryPlatforms = (platforms: string[] = []): string[] =>
	Array.from(
		new Set(
			platforms
				.map((platform) =>
					String(platform ?? '')
						.trim()
						.toLowerCase()
				)
				.filter(Boolean)
		)
	);

export const isContentFactoryUniversalPlatform = (platform = ''): boolean => {
	const normalized = String(platform ?? '')
		.trim()
		.toLowerCase();
	return (
		!normalized ||
		normalized === 'generic' ||
		normalized.includes('universal') ||
		normalized.includes('универсаль') ||
		normalized.includes('без площадк')
	);
};

export const extractExplicitContentFactoryPlatforms = (prompt = ''): string[] =>
	PLATFORM_DEFINITIONS.filter(({ pattern }) => pattern.test(String(prompt ?? ''))).map(
		({ id }) => id
	);

export const isAllContentFactoryPlatformsIntent = (prompt = ''): boolean =>
	ALL_PLATFORM_TARGET_PATTERNS.some((pattern) => pattern.test(String(prompt ?? '')));

export const isContentFactoryNoPlatformIntent = (prompt = ''): boolean =>
	CONTENT_FACTORY_NO_PLATFORM_PATTERNS.some((pattern) => pattern.test(String(prompt ?? '')));

const extractTargetedContentFactoryPlatforms = (prompt = ''): string[] => {
	const text = String(prompt ?? '');
	const detected = PLATFORM_DEFINITIONS.flatMap((definition) => {
		const match = definition.pattern.exec(text);
		if (!match || match.index === undefined) return [];
		const before = text.slice(Math.max(0, match.index - 48), match.index);
		const after = text.slice(match.index + match[0].length, match.index + match[0].length + 32);
		return CONTENT_FACTORY_TARGET_PREPOSITION_PATTERN.test(before) ||
			CONTENT_FACTORY_TARGET_SUFFIX_PATTERN.test(after) ||
			(CONTENT_FACTORY_CHANNEL_START_PATTERN.test(before) &&
				CONTENT_FACTORY_CHANNEL_OUTPUT_PATTERN.test(after))
			? [definition.id]
			: [];
	});
	const allExplicit = extractExplicitContentFactoryPlatforms(text);
	if (
		allExplicit.length > 1 &&
		(detected.length > 0 || CONTENT_FACTORY_MULTI_TARGET_ACTION_PATTERN.test(text))
	) {
		return allExplicit;
	}
	return detected;
};

export const resolveContentFactoryTargetPlatforms = ({
	prompt = '',
	connectedPlatforms = [],
	defaultToConnected = true
}: {
	prompt?: string;
	connectedPlatforms?: string[];
	defaultToConnected?: boolean;
}): ContentFactoryPlatformTargetResolution => {
	const normalizedConnected = normalizeContentFactoryPlatforms(connectedPlatforms);
	const explicitPlatforms = extractTargetedContentFactoryPlatforms(prompt);
	const allPlatformsRequested = isAllContentFactoryPlatformsIntent(prompt);
	const noPlatformRequested = isContentFactoryNoPlatformIntent(prompt);
	const targetPlatforms =
		noPlatformRequested
			? []
			: explicitPlatforms.length > 0
			? explicitPlatforms
			: allPlatformsRequested || (defaultToConnected && !noPlatformRequested)
				? normalizedConnected
				: [];

	return {
		explicitPlatforms,
		targetPlatforms,
		allPlatformsRequested
	};
};

export const formatContentFactoryPlatformLabel = (platform: string): string => {
	const normalized = String(platform ?? '')
		.trim()
		.toLowerCase();
	return (
		PLATFORM_DEFINITIONS.find(({ id }) => id === normalized)?.label ?? String(platform ?? '').trim()
	);
};

export const formatContentFactoryPlatformList = (platforms: string[]): string =>
	normalizeContentFactoryPlatforms(platforms)
		.map(formatContentFactoryPlatformLabel)
		.filter(Boolean)
		.join(', ');
